export const listFormatter = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});
